module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "node-label"
  }, [(_vm.topics.length) ? _c('field-topic', {
    attrs: {
      "color": _vm.labelColor,
      "topics": _vm.topics,
      "truncateLength": _vm.truncateLength
    }
  }) : (_vm.sections.length) ? _c('field-section', {
    attrs: {
      "color": _vm.labelColor,
      "sections": _vm.sections,
      "truncateLength": _vm.truncateLength
    }
  }) : _vm._e(), _vm._t("speechBalloonLabel"), (_vm.articleType === 'photo-essay') ? _c('span', {
    staticClass: "icon-wrapper icon-wrapper--photo"
  }, [_c('svg-icon-photo')], 1) : _vm._e(), (_vm.articleType === 'video') ? _c('span', {
    staticClass: "icon-wrapper icon-wrapper--video"
  }, [_c('svg-icon-video')], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75326514","hasScoped":false,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/node/Label.vue
// module id = 986
// module chunks = 1 2 3 6 24